export interface ScanFlags {
  isDangerousGoods: boolean;
  isWoodpacking: boolean;
}

export const isScanFlagEnabled = (value: unknown): boolean =>
  value === true || value === 1 || value === "Yes" || value === "yes";

export const getScanFlags = (data: any = {}): ScanFlags => {
  const source = data || {};
  return {
    isDangerousGoods: isScanFlagEnabled(
      source.isDangerousGoods ?? source.is_dangerous_goods ??
      source.commodityGroupIsDg ?? source.commodity_group_is_dg
    ),
    isWoodpacking: isScanFlagEnabled(
      source.isWoodpacking ?? source.is_woodpacking ?? source.sttWoodPacking ??
      source.stt_wood_packing ?? source.woodpacking ?? source.woodPacking
    )
  };
};

export const hasScanFlags = (data: any): boolean => {
  const flags = getScanFlags(data);
  return flags.isDangerousGoods || flags.isWoodpacking;
};
